export const SURVEY = 'SURVEY';
export const DIMENSION = 'DIMENSION';
export const QUESTION = 'QUESTION';
export const CHOICE = 'CHOICE';
export const LIST = 'LIST';
export const GRID = 'GRID';
export const VERTICAL = 'VERTICAL';
export const HORIZONTAL = 'HORIZONTAL';



// WEBPACK FOOTER //
// ./app/constants/index.js